import { loadScriptAsync, loadStyleAsync } from './../utils/loadResourceAsync';
import { handleModuleLoadingError } from './handleModuleLoadingError.js';

/**
 * @param {boolean} customErrorHandling pass TRUE to use custom error handling
 * @return {Promise<Dropzone, unknown>}
 */
export const loadDropzone = (customErrorHandling) => {
    const promise = Promise.all([
        loadScriptAsync('/js/dropzone.js'),
        loadStyleAsync('/css/vendors/dropzone.css'),
    ])
        // .then ensures that script and style are added to the DOM and processed before resolving
        .then(responses => new Promise(resolve => setTimeout(() => resolve(responses))));

    if (!customErrorHandling)
        promise.catch(handleModuleLoadingError);

    return promise;
};
